import React from "react";
import cn from "classnames";
import { ButtonOwnProps } from "./Button";
import styles from "./Button.module.scss";

export type TLinkProps = Omit<React.HTMLProps<HTMLAnchorElement>, "size"> & Omit<ButtonOwnProps, "type">;

export const Link = React.forwardRef<HTMLAnchorElement, TLinkProps>((props, ref) => {
  const { size = "default", className, variant, children, ...restComponentProps } = props;
  const classes = cn(styles["link"], styles["button"], styles[`variant-${variant}`], styles[`size-${size}`], className);

  return (
    <a ref={ref} className={classes} {...restComponentProps}>
      {children}
    </a>
  );
});

Link.displayName = Link.name;
